import React from "react";
import { HRProvider } from "../HRContext";
import Dashboard from "../Dashboard";

const HRDashboardWrapper: React.FC = () => {
  return (
    <HRProvider>
      <Dashboard />
    </HRProvider>
  );
};

export default HRDashboardWrapper;
